import React, { useEffect } from "react";
import { Counter } from "./example/App";
import Root from "./Pages/Root";

function App() {
  useEffect(() => {
    console.log(process.env.NODE_ENV, process.env.PUBLIC_URL);
  }, []);

  return (
    <div className="">
      <Root />
    </div>
  );
}

export default App;
